import BaseApi from '@/api/Base/BaseApi'
import { ModelPipelineMergeNodeInfo, UpdateMergeNodePayload } from '@/api/MergeNode/types'

const ROOT = '/merge'

export default class MergeNodeApi extends BaseApi {
  getMergeNode(mergeNodeId: string) {
    return this.agent.get<ModelPipelineMergeNodeInfo>(`${ROOT}/${mergeNodeId}`)
  }

  updateMergeNode(payload: UpdateMergeNodePayload) {
    const { mergeNodeId, ...rest } = payload
    return this.agent.put(`${ROOT}/${mergeNodeId}`, { ...rest })
  }
}
